import React, { Component } from "react";
import parse from 'html-react-parser';
import ReactDOM from 'react-dom';
import BookmarkArticle from './BookmarkArticle';
import {baseurl} from '../config/Settings';
import Pagination from "react-js-pagination";
import {getBookmarks} from '../config/Variables';
import InfiniteScroll from 'react-infinite-scroll-component';

export default class Fetchbookmarks extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      messagelog: '',
      isLoading: true,
      users: [],
      usersarray: [],
      numberstid: [],
      error: null,
      loading:true,
      totalitems:5,
      activePage: 1,
      lengthusers: 111110
    }   
    this.handlePageChange = this.handlePageChange.bind(this);
  }
  

  getFetchNewsletter() {
    if (localStorage.getItem('user-info')) {

    var urllink=baseurl + this.props.url;

    this.setState({
        loading: true
    }, () => {
        fetch(urllink).then(res => res.json()).then(result => this.setState({
            loading: false,
            users: result
        })).catch(console.log);
    });
  }else{
      var domainurl=  window.location.origin;
      window.location.href = domainurl+'/journey';
  }
}
handlePageChange(pageNumber) {
  this.setState({usersarray: []});
const page =pageNumber;
const per_page =5;
var bundle=this.props.contenttype;

  if (localStorage.getItem('user-info')) {
    const isLoading = true;
    let item = { isLoading,page,per_page,bundle };
    let user = JSON.parse(localStorage.getItem('user-info'))
    let datt = fetch(getBookmarks, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization": "Bearer " + user.token.access_token,
      },
      body: JSON.stringify(item)
    }).then(response => response.json())
      .then(data => {
       
     //temp   this.state.totalitems=  data.pager.total_item;
        //temppagintion this.setState({totalitems: data.pager.total_item});
        
        
        data.data.map(({ nid }, index2) => {

          this.state.usersarray.push(nid);

        });
      //  this.state.lengthusers=data.data.length;
        
     this.setState({lengthusers:data.data.length});
     //temp   this.state.totalitems=  data.pager.total_item;
        //this.setState({totalitems: data.pager.total_item});
        var userstring = this.state.usersarray.join('+');
        
        if (localStorage.getItem('user-info')) {
          if(data.data.length>0){
          var urllink=baseurl + this.props.urlrelativepath+"/"+userstring;

          this.setState({
              loading: true
          }, () => {
              fetch(urllink).then(res => res.json()).then(result => this.setState({
                  loading: false,
                  users: result
              })).catch(console.log);
          });
        }
        }else{
            var domainurl=  window.location.origin;
            window.location.href = domainurl+'/journey';
        }



//console.log(userstring);

      });
  }


 



  this.setState({activePage: pageNumber});
}

componentDidMount() {
    this.handlePageChange(1);
}
runAfterRender = () => 
{
  const myElem = document.getElementById("myElem")
  if(myElem)
  {
    //do important stuff
  }
}

render() {
  const {
    users,
    error,
    totalitems,
    loading,
    lengthusers
  } = this.state;
  console.log(lengthusers);
  console.log("lebanadsadsdason");
  console.log(this.props.contenttype);

   if(this.state.loading ==false && this.props.contenttype=="opinion"){
    var script = document.createElement('script'); script.type = 'text/javascript'; script.src = 'https://aawsat.com/themes/custom/aawsatv3/assets/js/app.js?fevssss='; document.head.appendChild(script);
  }

 
if(this.state.loading ==false && this.props.contenttype=="opinion"){
  var scriptaudiofile = document.createElement('script'); scriptaudiofile.type = 'text/javascript'; scriptaudiofile.src = 'https://aawsat.com/themes/custom/aawsatv3/assets/js/modules/audio-players.gn.js?sssssss'; document.head.appendChild(scriptaudiofile);
}
if(this.state.loading ==false && this.props.contenttype=="opinion"){
  var scriptaudio = document.createElement('script'); scriptaudio.type = 'text/javascript'; scriptaudio.src = 'https://aawsat.com/themes/custom/aawsatv3/assets-react/js/custom_js.js?xssssss'; document.head.appendChild(scriptaudio);
}


  
if(this.state.loading ==false && this.props.contenttype=="article"){
  //var scriptaudiolazy = document.createElement('script'); scriptaudiolazy.type = 'text/javascript'; scriptaudiolazy.src = 'https://aawsat.com/themes/custom/aawsatv3/assets/js/lib/jquery.lazy.min.gn.js?ysstrs?rsgatplfsfsfsd'; document.head.appendChild(scriptaudiolazy);
  //console.log("here");

  setTimeout(() => {
    const collection = document.getElementsByClassName("bookmark_user");
    if(collection.length>0){
    for (let i = 0; i < collection.length; i++) {
      ReactDOM.render(
        <React.StrictMode>
          <BookmarkArticle nodeid={collection[i].getAttribute('data-value')} />
        </React.StrictMode>,
      document.getElementsByClassName("bookmark_user")[i]
      );
  
        }
      }
  }, 1000);

 
}
if(lengthusers ==111110){
  return(
    <>
    {loading ? <div className="loading-mypage">   <img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?ssss"/></div>: ""}
    </>
    );
} if(lengthusers ==0  && loading==true){
  return(
<div className="cell small-12 large-9 c-tab-content_js tab-active" data-id="myTags">
<div className="content-wrap vertical-scroll"> 
    <div className="section-wrapper">
        <div className="section-title style-v2 show-for-large">
            <h3></h3>
            <div className="more"><a href="#"><i className="icomoon-icon icon-arrow-left hide"></i></a></div>
        </div>
        <div className="section-content"> 
<div className="category-content">
                                               <div className="empty-content">
                                                  <div className="empty-content-img">
                                                      <img src={`${baseurl}themes/custom/aawsatv3/assets/img/icon/search.svg`} alt="search"/>
                                                  </div>
                                                  <div className="empty-content-text">
                                                  لا يوجد {this.props.labelname}
                                                  </div>
                                                  <div className="emtpty-content-button">
                                                      
                                                  </div>
                                               </div>
                                          </div>
                                          </div>
                                          </div>
                                          </div>
                                          </div>
  );

}else{


  return (
    <>
{ users.length<1  ?  "" :
 
   
<>
<div className={this.props.classwrapper} > 
            <React.Fragment>
              {
                users.map(({ rendered_entity }, index) => {
              
                    return (
                      <>
                        {parse(rendered_entity)}
                        </>
                    );
                })
              }
            </React.Fragment> 
        
  
 


 

            <div className="cell text-center react-pager ">
            {/*<Pagination
            activePage={this.state.activePage}
            itemsCountPerPage={1}
            totalItemsCount={10}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
            />*/}
            
          </div>
          </div>
            </>
           
               

}
</>
);
}}
}
